import { render, staticRenderFns } from "./passwd-update.vue?vue&type=template&id=2a85d7fc&scoped=true&"
import script from "./passwd-update.vue?vue&type=script&lang=js&"
export * from "./passwd-update.vue?vue&type=script&lang=js&"
import style0 from "./passwd-update.vue?vue&type=style&index=0&id=2a85d7fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a85d7fc",
  null
  
)

export default component.exports